import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import restProductService from 'services/rest/product';
import brandService from 'services/rest/brand';
import restShopService from 'services/rest/shop';
import { BASE_URL, IMG_URL, WEBSITE_URL } from 'configs/app-global';

const DEFAULT_IMAGE = 'https://via.placeholder.com/800x600/efe7dd/6b3f21?text=Product';
const styles = `
  .landing-root { background:#ffffff; min-height:100vh; font-family:"Segoe UI", Tahoma, Arial, sans-serif; color:#2b1a10; }
  .landing-wrapper { max-width:1200px; margin:0 auto; padding:40px 24px 72px; }
  .status-card { background:rgba(255,246,240,0.92); border-radius:18px; padding:32px; text-align:center; box-shadow:0 12px 30px rgba(0,0,0,0.08); backdrop-filter:blur(8px); }
  .status-card.error { border:1px solid #d9534f; color:#a63b36; }
  .status-card button { margin-top:16px; background:#6b3f21; color:#fff; border:none; border-radius:8px; padding:10px 18px; cursor:pointer; }
  .page-grid { display:flex; flex-wrap:wrap; gap:28px; }
  .media-card, .details-card, .info-card { background:#fff8f3; border-radius:18px; box-shadow:0 14px 32px rgba(43,26,16,0.08); padding:28px; }
  .media-card { flex:1 1 420px; }
  .details-card { flex:1 1 420px; }
  .info-card { margin-top:24px; }
  .carousel-main { position:relative; border-radius:18px; overflow:hidden; background:#fff; height:420px; max-height:60vh; aspect-ratio:4 / 3; }
  .carousel-main img { width:100%; height:100%; object-fit:cover; display:block; }
  .carousel-control { position:absolute; top:50%; transform:translateY(-50%); background:rgba(255,255,255,0.92); border:none; width:44px; height:44px; border-radius:18px; cursor:pointer; color:#6b3f21; font-size:20px; font-weight:700; box-shadow:0 12px 30px rgba(0,0,0,0.15); transition:transform 0.2s ease, box-shadow 0.2s ease; }
  .carousel-control:hover { transform:translateY(-50%) scale(1.05); box-shadow:0 16px 32px rgba(0,0,0,0.2); }
  .carousel-control.prev { left:14px; }
  .carousel-control.next { right:14px; }
  .thumbnails { display:flex; flex-wrap:wrap; gap:12px; justify-content:center; margin-top:18px; }
  .thumbnail { width:74px; height:74px; border-radius:14px; overflow:hidden; border:2px solid transparent; cursor:pointer; background:#fff; padding:0; }
  .thumbnail img { width:100%; height:100%; object-fit:cover; display:block; }
  .thumbnail.active { border-color:#6b3f21; }
  .badge-discount { background:#e1b86e; color:#2b1a10; padding:6px 12px; border-radius:999px; font-size:0.9rem; font-weight:600; }
  .price-block { margin:18px 0; }
  .price-old { text-decoration:line-through; color:#8a6b56; margin-left:12px; font-size:1rem; }
  .price-new { font-weight:700; font-size:1.7rem; color:#6b3f21; }
  .muted { color:#8a6b56; font-size:0.95rem; }
  .heading-row { display:flex; justify-content:space-between; align-items:flex-start; gap:18px; margin-bottom:16px; }
  .title-block { flex:1; }
  .title-meta { margin:0 0 6px; font-size:0.95rem; color:#8a6b56; letter-spacing:0.5px; text-transform:uppercase; }
  .product-title { margin:0; font-size:2rem; color:#2b1a10; line-height:1.3; }
  .short-desc { margin:0; }
  .feature-grid { display:grid; grid-template-columns:repeat(auto-fit, minmax(200px, 1fr)); gap:14px; margin-top:12px; }
  .feature-item { background:#fff; border-radius:14px; padding:14px; font-size:0.95rem; box-shadow:0 10px 24px rgba(0,0,0,0.05); }
  .feature-item strong { display:block; font-size:1.05rem; color:#392113; }
  .media-section { margin-top:20px; }
  .audio-block { margin-bottom:20px; }
  .audio-block audio { width:100%; }
  .video-block { margin-bottom:0; }
  .section-label { display:block; font-weight:600; margin-bottom:6px; color:#392113; }
  .section-heading { margin:20px 0 10px; font-size:1rem; color:#392113; }
  .video-wrapper { margin-top:8px; position:relative; padding-bottom:56.25%; height:0; border-radius:12px; overflow:hidden; background:#000; }
  .video-wrapper iframe, .video-wrapper video { position:absolute; top:0; left:0; width:100%; height:100%; border:0; }
  .info-card ul { margin:0; padding-inline-start:20px; }
  .info-card li { margin-bottom:6px; }
  .share-link { margin-top:12px; font-size:0.9rem; }
  .share-link a { color:#6b3f21; text-decoration:none; border-bottom:1px solid #6b3f21; }
  .footer-note { margin-top:40px; text-align:center; font-size:0.85rem; color:#8a6b56; }
  .app-links { margin-top:16px; display:flex; flex-wrap:wrap; gap:12px; justify-content:center; }
  .app-link-btn { display:inline-flex; align-items:center; gap:8px; background:#2b1a10; color:#fff; padding:10px 16px; border-radius:999px; text-decoration:none; font-size:0.9rem; box-shadow:0 10px 20px rgba(43,26,16,0.2); transition:transform 0.2s ease, box-shadow 0.2s ease; }
  .app-link-btn:hover { transform:translateY(-2px); box-shadow:0 14px 24px rgba(43,26,16,0.25); }
  .app-link-btn.apple { background:#000000; }
  .app-link-btn.android { background:#2c6b2f; }
  .app-link-icon { width:20px; height:20px; display:inline-flex; align-items:center; justify-content:center; font-size:1.1rem; }
  @media (max-width: 900px) {
    .landing-wrapper { padding:32px 18px 60px; }
    .page-grid { flex-direction:column; gap:22px; }
    .media-card, .details-card { padding:24px; }
    .carousel-main { height:320px; }
    .heading-row { flex-direction:column; align-items:flex-start; }
    .price-block small { display:block; margin-top:10px; }
  }
  @media (max-width: 768px) {
    .thumbnail { width:66px; height:66px; border-radius:12px; }
    .carousel-control { width:38px; height:38px; font-size:18px; }
    .feature-grid { grid-template-columns:repeat(auto-fit, minmax(170px, 1fr)); }
  }
  @media (max-width: 600px) {
    .carousel-main { height:240px; }
    .landing-wrapper { padding:26px 14px 48px; }
    .product-title { font-size:1.6rem; }
    .media-card, .details-card { padding:20px; }
  }
  @media (max-width: 480px) {
    .carousel-main { height:200px; }
    .landing-wrapper { padding:22px 12px 42px; }
    .feature-grid { grid-template-columns:repeat(auto-fit, minmax(150px, 1fr)); }
    .share-link { word-break:break-all; }
  }
`;

const stripHtml = (value = '') => value.replace(/<[^>]+>/g, '').trim();

const ensureAbsoluteUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('//')) return `https:${path}`;
  const base = (IMG_URL || `${BASE_URL}/storage/`).replace(/\/$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return `${base}/${normalizedPath}`;
};

const buildYoutubeEmbed = (url = '') => {
  if (!url) return '';
  const applyAutoplay = (embedUrl) => {
    if (!/(youtube\.com|youtu\.be)/i.test(embedUrl)) {
      return embedUrl;
    }
    try {
      const parsed = new URL(embedUrl, 'https://www.youtube.com');
      parsed.searchParams.set('autoplay', '0');
      parsed.searchParams.delete('mute');
      parsed.searchParams.set('playsinline', '1');
      parsed.searchParams.set('rel', '0');
      return parsed.toString();
    } catch (error) {
      const joiner = embedUrl.includes('?') ? '&' : '?';
      return `${embedUrl}${joiner}autoplay=0&playsinline=1&rel=0`;
    }
  };
  try {
    const directIdMatch = url.match(/[?&]v=([^&#]+)/);
    if (directIdMatch) {
      return applyAutoplay(`https://www.youtube.com/embed/${directIdMatch[1]}`);
    }
    const shortMatch = url.match(/youtu\.be\/([^?&#]+)/);
    if (shortMatch) {
      return applyAutoplay(`https://www.youtube.com/embed/${shortMatch[1]}`);
    }
    if (url.includes('youtube.com/embed/')) {
      return applyAutoplay(url);
    }
    return applyAutoplay(url);
  } catch (err) {
    return applyAutoplay(url);
  }
};

const toNumber = (value) => {
  if (value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const normalizeRecord = (record) => {
  if (!record) return null;
  const base = record.product || record;
  return {
    ...record,
    ...base,
    translation: base.translation || record.translation,
    galleries: (base.galleries && base.galleries.length ? base.galleries : record.galleries) || [],
    stocks: (base.stocks && base.stocks.length ? base.stocks : record.stocks) || [],
    shop: record.shop || base.shop || null,
    currency: record.currency || base.currency || (record.shop && record.shop.currency) || (base.shop && base.shop.currency) || null,
    audio: base.audio || record.audio || '',
    youtube: base.youtube || base.video || record.youtube || record.video || '',
  };
};

const pickFirstRecord = (payload) => {
  if (!payload) return null;
  if (Array.isArray(payload)) {
    return payload[0] || null;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data[0] || null;
  }
  if (Array.isArray(payload?.payload)) {
    return payload.payload[0] || null;
  }
  if (Array.isArray(payload?.result)) {
    return payload.result[0] || null;
  }
  return payload.data || payload.payload || payload.result || null;
};

const enrichProductRelations = async (product, { shopId, uuid }) => {
  if (!product) return product;
  let enriched = { ...product };
  const needsShop = !enriched.shop && Boolean(shopId);
  const needsCategory = !enriched.category && Boolean(enriched.category_id || enriched.categories?.length);
  const needsBrand = !enriched.brand && Boolean(enriched.brand_id);

  if ((needsShop || needsCategory) && uuid) {
    try {
      const searchResponse = await restProductService.search({ shop_id: shopId, search: uuid, perPage: 1 });
      const searchCandidate = pickFirstRecord(searchResponse);
      if (searchCandidate) {
        const normalizedSearch = normalizeRecord(searchCandidate);
        enriched = {
          ...enriched,
          shop: enriched.shop || normalizedSearch?.shop || enriched.shop,
          category: enriched.category || normalizedSearch?.category || enriched.category,
          brand: enriched.brand || normalizedSearch?.brand || enriched.brand,
          categories: Array.isArray(enriched.categories) && enriched.categories.length
            ? enriched.categories
            : normalizedSearch?.categories,
          brands: Array.isArray(enriched.brands) && enriched.brands.length ? enriched.brands : normalizedSearch?.brands,
        };
      }
    } catch (searchError) {
      // silently ignore, we will fallback to other public endpoints
    }
  }

  if (!enriched.shop && shopId) {
    try {
      const shopResponse = await restShopService.getById(shopId);
      enriched.shop = shopResponse?.data || shopResponse || enriched.shop;
    } catch (shopError) {
      // ignore, shop name will stay as fallback value
    }
  }

  if (!enriched.brand && enriched.brand_id) {
    try {
      const brandResponse = await brandService.getById(enriched.brand_id);
      enriched.brand = brandResponse?.data || brandResponse || enriched.brand;
    } catch (brandError) {
      // ignore
    }
  }

  return enriched;
};

const getEntityTitle = (entity) => {
  if (!entity && entity !== 0) return '';
  if (typeof entity === 'string') return entity.trim();
  if (typeof entity === 'number') return String(entity);
  return (
    entity.translation?.title ||
    entity.title ||
    entity.label ||
    entity.name ||
    entity.full_name ||
    entity.slug ||
    ''
  );
};

const resolveEntityTitle = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate === undefined || candidate === null) {
      continue;
    }
    if (typeof candidate === 'function') {
      const fnValue = candidate();
      const resolvedFromFn = resolveEntityTitle(fnValue);
      if (resolvedFromFn) return resolvedFromFn;
      continue;
    }
    if (Array.isArray(candidate)) {
      const resolvedFromArray = resolveEntityTitle(...candidate);
      if (resolvedFromArray) return resolvedFromArray;
      continue;
    }
    if (typeof candidate === 'string' || typeof candidate === 'number') {
      const normalized = String(candidate).trim();
      if (normalized) return normalized;
      continue;
    }
    const title = getEntityTitle(candidate);
    if (title) return title;
  }
  return '';
};

const ProductLandingPage = () => {
  const { shopId, uuid } = useParams();
  const [state, setState] = useState({ loading: true, product: null, error: null });
  const [activeImage, setActiveImage] = useState(0);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!shopId || !uuid) {
      setState({ loading: false, product: null, error: 'المسار غير صالح' });
      return undefined;
    }
    let ignore = false;

    const fetchProduct = async () => {
      setState({ loading: true, product: null, error: null });
      try {
        const directResponse = await restProductService.getByID(uuid, { shop_id: shopId });
        let productCandidate = directResponse?.data || directResponse?.payload || directResponse;
        if (Array.isArray(productCandidate)) {
          productCandidate = productCandidate[0];
        }

        if (!productCandidate) {
          const idsResponse = await restProductService.getProductByIds({ shop_id: shopId, [`ids[0]`]: uuid });
          const listCandidate = Array.isArray(idsResponse?.data)
            ? idsResponse.data
            : Array.isArray(idsResponse?.payload)
            ? idsResponse.payload
            : Array.isArray(idsResponse?.result)
            ? idsResponse.result
            : [];
          productCandidate = listCandidate[0] || idsResponse?.data?.data?.[0] || idsResponse?.data || idsResponse;
        }

        const product = normalizeRecord(productCandidate);
        if (!product) {
          throw new Error('لم يتم العثور على المنتج');
        }
        const hydratedProduct = await enrichProductRelations(product, { shopId, uuid });
        if (ignore) return;
        setState({ loading: false, product: hydratedProduct, error: null });
        setActiveImage(0);
      } catch (err) {
        if (ignore) return;
        const errorMessage = err?.response?.data?.message || err?.message || 'تعذر تحميل بيانات المنتج';
        setState({ loading: false, product: null, error: errorMessage });
      }
    };

    fetchProduct();

    return () => {
      ignore = true;
    };
  }, [shopId, uuid, reloadKey]);

  const viewModel = useMemo(() => {
    if (!state.product) return null;
    const translation = state.product.translation || {};
    const title = translation.title || state.product.title || 'منتج بدون اسم';
    const description = stripHtml(translation.description || state.product.description || '');
    const shortDescription = translation.short_desc || description.split(/\n+/)[0] || '';
    const images = (state.product.galleries || [])
      .map((item, index) => ({
        id: item.id || index,
        url: ensureAbsoluteUrl(item.path || item.url || ''),
      }))
      .filter((item) => item.url);
    if (!images.length && state.product.img) {
      images.push({ id: 'main-img', url: ensureAbsoluteUrl(state.product.img) });
    }
    if (!images.length) {
      images.push({ id: 'placeholder', url: DEFAULT_IMAGE });
    }

    const stocks = Array.isArray(state.product.stocks) ? state.product.stocks : [];
    const defaultStock = stocks.find((stock) => stock?.stock?.default) || stocks[0] || {};
    const price = toNumber(defaultStock.price ?? state.product.price);
    const discount = toNumber(defaultStock.discount ?? state.product.discount);
    const tax = toNumber(state.product.tax);
    const finalPrice = price !== null ? Math.max(price - (discount || 0), 0) : null;
    const discountPercent = price && discount ? Math.round((discount / price) * 100) : null;
    const taxIsPercent = tax !== null && tax <= 100;
    const taxAmount = finalPrice !== null && tax !== null
      ? taxIsPercent
        ? (finalPrice * tax) / 100
        : tax
      : null;
    const totalPrice = finalPrice !== null ? finalPrice + (taxAmount || 0) : null;
    const totalPriceBeforeDiscount = price !== null && tax !== null
      ? price + (taxIsPercent ? (price * tax) / 100 : tax)
      : price;
    const currencySymbol = 'EGP';
    const categoriesCollection = Array.isArray(state.product.categories) ? state.product.categories : [];
    const brandsCollection = Array.isArray(state.product.brands) ? state.product.brands : [];

    const shopName = resolveEntityTitle(
      state.product.shop,
      state.product.product?.shop,
      state.product.shop_data,
      state.product.shop_info,
      state.product.shopDetails,
      state.product.shop_detail,
      state.product.seller?.shop,
      state.product.seller_shop,
      state.product.order?.shop,
      state.product.shopTranslation,
      state.product.shop_translation,
      state.product.shop_title,
      state.product.shop_label,
      state.product.shop_name,
    );

    const categoryName = resolveEntityTitle(
      state.product.category,
      state.product.product?.category,
      categoriesCollection,
      state.product.category_data,
      state.product.category_info,
      state.product.categoryDetails,
      state.product.category_detail,
      state.product.shop_category,
      state.product.shopCategory,
      state.product.categoryTranslation,
      state.product.category_translation,
      state.product.category_title,
      state.product.category_label,
      state.product.category_name,
    );

    const brandName = resolveEntityTitle(
      state.product.brand,
      state.product.product?.brand,
      brandsCollection,
      state.product.brand_data,
      state.product.brand_info,
      state.product.brandDetails,
      state.product.brand_detail,
      state.product.brandTranslation,
      state.product.brand_translation,
      state.product.brand_title,
      state.product.brand_label,
      state.product.brand_name,
    );

    const fallbackValue = 'غير متوفر';

    const requiredFeatures = [
      { label: 'اسم المتجر', value: shopName || fallbackValue },
      { label: 'القسم', value: categoryName || fallbackValue },
      { label: 'البرند', value: brandName || fallbackValue },
    ];

    const optionalFeatures = [
      (state.product.unit?.translation?.title || state.product.unit?.title) && {
        label: 'وحدة القياس',
        value: state.product.unit?.translation?.title || state.product.unit?.title,
      },
      state.product.kcal && { label: 'السعرات الحرارية', value: `${state.product.kcal} kcal` },
      state.product.protein && { label: 'البروتين', value: `${state.product.protein} g` },
      state.product.carbs && { label: 'الكربوهيدرات', value: `${state.product.carbs} g` },
      state.product.fats && { label: 'الدهون', value: `${state.product.fats} g` },
    ].filter(Boolean);

    const nutrientFeatures = [...requiredFeatures, ...optionalFeatures];

    const audioSrc = ensureAbsoluteUrl(state.product.audio);
    const youtubeEmbed = buildYoutubeEmbed(state.product.youtube);
    const shareUrl = typeof window !== 'undefined' ? window.location.href : `${WEBSITE_URL.replace(/\/$/, '')}/qr/product/${shopId}/${uuid}`;

    return {
      title,
      shortDescription,
      description,
      images,
      price,
      discount,
      finalPrice,
      tax,
      taxIsPercent,
      taxAmount,
      totalPrice,
      totalPriceBeforeDiscount,
      discountPercent,
      currencySymbol,
      nutrientFeatures,
      audioSrc,
      youtubeEmbed,
      shopName,
      categoryName,
      brandName,
      shareUrl,
    };
  }, [state.product, shopId, uuid]);

  useEffect(() => {
    if (!viewModel?.title) return undefined;
    const previousTitle = document.title;
    document.title = `${viewModel.title} | FoodieCity`;
    return () => {
      document.title = previousTitle;
    };
  }, [viewModel?.title]);

  const handlePrev = () => {
    setActiveImage((current) => {
      if (!viewModel) return current;
      return (current - 1 + viewModel.images.length) % viewModel.images.length;
    });
  };

  const handleNext = () => {
    setActiveImage((current) => {
      if (!viewModel) return current;
      return (current + 1) % viewModel.images.length;
    });
  };

  const formatPrice = (amount) => {
    if (amount === null || amount === undefined) return '—';
    const numeric = Number(amount);
    if (!Number.isFinite(numeric)) return amount;
    return `${viewModel?.currencySymbol || ''} ${numeric.toFixed(2)}`;
  };

  const handleRetry = () => setReloadKey((key) => key + 1);

  return (
    <div className='landing-root' dir='rtl'>
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className='landing-wrapper'>
        {state.loading && <div className='status-card'>جار تحميل بيانات المنتج...</div>}
        {!state.loading && state.error && (
          <div className='status-card error'>
            <p>{state.error}</p>
            <button type='button' onClick={handleRetry}>إعادة المحاولة</button>
          </div>
        )}
        {!state.loading && !state.error && viewModel && (
          <>
            <div className='page-grid'>
              <section className='media-card'>
                <div className='carousel-main'>
                  <img src={viewModel.images[activeImage]?.url} alt={`صورة ${viewModel.title}`} />
                  {viewModel.images.length > 1 && (
                    <>
                      <button type='button' className='carousel-control prev' onClick={handlePrev} aria-label='السابق'>‹</button>
                      <button type='button' className='carousel-control next' onClick={handleNext} aria-label='التالي'>›</button>
                    </>
                  )}
                </div>
                {viewModel.images.length > 1 && (
                  <div className='thumbnails'>
                    {viewModel.images.map((item, index) => (
                      <button
                        type='button'
                        key={item.id}
                        className={`thumbnail ${index === activeImage ? 'active' : ''}`}
                        onClick={() => setActiveImage(index)}
                        aria-label={`عرض الصورة ${index + 1}`}
                      >
                        <img src={item.url} alt={viewModel.title} />
                      </button>
                    ))}
                  </div>
                )}
              </section>

              <section className='details-card'>
                <div className='heading-row'>
                  <div className='title-block'>
                    {viewModel.shopName && <div className='title-meta'>{viewModel.shopName}</div>}
                    <h1 className='product-title'>{viewModel.title}</h1>
                    {viewModel.shortDescription && <p className='muted short-desc'>{viewModel.shortDescription}</p>}
                  </div>
                  {viewModel.discountPercent && (
                    <span className='badge-discount'>خصم {viewModel.discountPercent}%</span>
                  )}
                </div>

                <div className='price-block'>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
                    {viewModel.discountPercent && (
                      <div className='price-old'>{formatPrice(viewModel.totalPriceBeforeDiscount)}</div>
                    )}
                    <div className='price-new'>
                        {formatPrice(viewModel.totalPrice ?? (viewModel.discountPercent ? viewModel.finalPrice : viewModel.price))}
                    </div>
                  </div>
                  <small className='muted'>السعر شامل الضريبة</small>
                </div>

                {viewModel.nutrientFeatures.length > 0 && (
                  <div>
                    <h6 className='section-heading'>مواصفات المنتج</h6>
                    <div className='feature-grid'>
                      {viewModel.nutrientFeatures.map((feature) => (
                        <div className='feature-item' key={feature.label}>
                          <span className='muted'>{feature.label}</span>
                          <strong>{feature.value}</strong>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className='media-section'>
                  <div className='audio-block'>
                    <span className='section-label'>شرح صوتي</span>
                    {viewModel.audioSrc ? (
                      <audio controls src={viewModel.audioSrc} />
                    ) : (
                      <div className='muted'>لا يتوفر ملف صوتي لهذا المنتج حالياً.</div>
                    )}
                  </div>
                  <div className='video-block'>
                    <span className='section-label'>فيديو توضيحي</span>
                    {viewModel.youtubeEmbed ? (
                      <div className='video-wrapper'>
                        <iframe
                          src={viewModel.youtubeEmbed}
                          title={`فيديو ${viewModel.title}`}
                          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                          allowFullScreen
                        />
                      </div>
                    ) : (
                      <div className='muted'>لا يوجد فيديو مرفق، يمكنك التواصل مع المتجر لمزيد من التفاصيل.</div>
                    )}
                  </div>
                </div>

                <div className='share-link'>
                  رابط المشاركة: <a href={viewModel.shareUrl} target='_blank' rel='noreferrer'>{viewModel.shareUrl}</a>
                </div>
              </section>
            </div>

            <section className='info-card'>
              <h5>وصف المنتج</h5>
              <p>{viewModel.description || 'لا يوجد وصف تفصيلي متاح لهذا المنتج.'}</p>
            </section>

            <div className='footer-note'>
              © {new Date().getFullYear()} — يمكن مشاركة هذا الرابط مع عملائك للاطلاع على تفاصيل المنتج مباشرةً.
              <div className='app-links'>
                <a
                  className='app-link-btn apple'
                  href='https://apps.apple.com/eg/app/foodiecity/id6738578051'
                  target='_blank'
                  rel='noreferrer'
                >
                  <span className='app-link-icon' aria-hidden='true'></span>
                  تحميل تطبيق الايفون
                </a>
                <a
                  className='app-link-btn android'
                  href='https://play.google.com/store/apps/details?id=com.foodieCodi.eg'
                  target='_blank'
                  rel='noreferrer'
                >
                  <span className='app-link-icon' aria-hidden='true'>▶</span>
                  تحميل تطبيق الاندرويد
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductLandingPage;
